import { render, staticRenderFns } from "./address-block.vue?vue&type=template&id=409a7a54"
import script from "./address-block.vue?vue&type=script&lang=ts"
export * from "./address-block.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports